module.exports = __webpack_public_path__ + "img/icon_police_04.09584292.png";